// extracted by mini-css-extract-plugin
export default {"data-list":"data-list_data-list__c0uSG","data-list--without-lines":"data-list_data-list--without-lines__gGDsI"};